import React, { Fragment, useState, useEffect, useMemo } from "react";
import {
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
} from "reactstrap";
import { Btn, H5, UL, H6, LI } from "../../../AbstractElements";
import { useTranslation } from 'react-i18next';
import {
  EmailAddress,
  LoginWithJWT,
  Password,
  SignIn,
} from "../../../Constant";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { firebase_app, Jwt_token } from "../../../Config/Config";
import man from "../../../assets/images/dashboard/1.png";
import { handleResponse } from "../../../Services/Fack.Backend";
import FormHeader from "./FormHeader";
import FormPassword from "./FormPassword";
import SignInWith from "./SignInWith";
import { Phone, Lock, Key } from "react-feather";
import axios from "axios";
import Language from "../../../Layout/Header/Langauge";

const LoginTab = ({ selected }) => {
  const [phone_number, setPhoneNumber] = useState("");
  const [step, setStep] = useState(false);
  const [step3, setStep3] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [disabled2, setDisabled2] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [step2, setStep2] = useState(false);
  const [otpCode, setOtpCode] = useState();
  const lang = localStorage?.getItem('i18nextLng');
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [togglePassword, setTogglePassword] = useState(false);
  const [togglePassword2, setTogglePassword2] = useState(false);
  const history = useNavigate();

  const [value, setValue] = useState(localStorage.getItem("profileURL" || man));
  //const [name, setName] = useState(localStorage.getItem("Name"));

  useEffect(() => {
    localStorage.setItem("profileURL", value);
    ///localStorage.setItem("Name", name);
  }, [value]);

const validatePassword = (password) => {
  const lengthValid = password.length >= 8;
  const upperCaseValid = /[A-Z]/.test(password);
  const lowerCaseValid = /[a-z]/.test(password);
  const numberValid = /[0-9]/.test(password);
  const specialCharValid = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  return {
      lengthValid,
      upperCaseValid,
      lowerCaseValid,
      numberValid,
      specialCharValid,
  };
};

const validation = useMemo(() => validatePassword(password), [password]);

useEffect(() => {
  if (password !== '') {
          if(validation && validation.lengthValid && validation.upperCaseValid && validation.lowerCaseValid && validation.numberValid && validation.specialCharValid) {
              setIsDisabled(false);
          } else {
              setIsDisabled(true);
          }
  } else {
      setIsDisabled(true);
  }
},[password, validation]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (password?.trim() !== "" && !isDisabled) {
    try {
      let link;
      if(step) {
        link = "https://api-portal.nada.org.np/api/users/register-bulk"
      } else {
        link = "https://api-portal.nada.org.np/api/users/login"
      }
      const response2 = await axios.post(
        link,
        {
          phone_number: phone_number,
          password: password,
        }
      );
      if (response2?.data?.success) {
        localStorage.setItem("token", response2?.data?.data?.token);
        localStorage.setItem("currentUser", response2?.data?.data?.phone_number);
        localStorage.setItem("authenticated", "true");
        const name = response2?.data?.data?.name ? response2?.data?.data?.name : 'null';
        const image = response2?.data?.data?.profile_pic ? response2?.data?.data?.profile_pic : 'null';
        const position = response2?.data?.data?.position ? response2?.data?.data?.position : 'null';
        localStorage.setItem("image", image);
        localStorage.setItem("position", position);
        localStorage.setItem("Name", name);
        toast.success("Logged in  successfully!")
        window.location.href = `${process.env.PUBLIC_URL}/dashboard`;
      } else {
        toast.error(response2?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      if (error.response) {
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
    }
  } else {
    toast.error("Please enter valid password");
  }
  };


  const handleLogin2 = async (e) => {
    e.preventDefault();
    try {
      const response2 = await axios.post(
        "https://api-portal.nada.org.np/api/users/verify-status",
        {
          phone_number: phone_number
        }
      );
      if (response2?.data?.success) {
        if(response2?.data?.message === "login") {
          setStep2(true);
        } else {
          setStep(true);
          setDisabled(true);
        }
      } else {
        toast.error(response2?.data?.message, 'hey');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      if (error.response) {
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
    }
  };

  const handleOtp = async (e) => {
    //setStep2(true);
    e.preventDefault();
    if (otpCode !== "" && otpCode?.length === 4) {
    try {
      const response2 = await axios.post(
        "https://api-portal.nada.org.np/api/users/verify-otp",
        {
          phone_number: phone_number,
          otp_code: otpCode,
        }
      );
      if (response2?.data?.success) {
        if (response2?.data?.success) {
          setStep2(true);
          setDisabled2(true);
        } else {
          toast.error(response2?.data?.message);
        }
      } else {
        toast.error(response2?.data?.message, 'hey');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      if (error.response) {
      } else if (error.request) {
        console.error("Error request:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
    }
    } else {
      toast.error("Please enter valid OTP");
    }
  };


  return (
    <Fragment
    style={{ height: "1100px" }}
    >
      <Form
      className="theme-form login-form"
      //style={{ overflowY: 'auto', height: "1100px" }}
      >
        <FormHeader selected={selected} t={t} />
        <FormGroup>
          <Label>{t("Phone Number")}</Label>
          <InputGroup>
            <InputGroupText>
              <Phone />
            </InputGroupText>
            <Input
              className="form-control"
              type="number"
              required=""
              disabled={disabled}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Enter the phone number"
              value={phone_number}
            />
          </InputGroup>
        </FormGroup>
        {step &&
        <FormGroup>
            <Label>{t("OTP Code")}</Label>
            <InputGroup>
              <span className="input-group-text">
                <Key />
              </span>
              <Input
                className="form-control"
                type={togglePassword2 ? "text" : "password"}
                //name="login[password]"
                required=""
                disabled={disabled2}
                maxLength={4}
                onChange={(e) => setOtpCode(e.target.value)}
                value={otpCode}
                placeholder={t("Enter 4-digit code")}
              />
              <div
              className="show-hide"
              onClick={() => setTogglePassword2(!togglePassword)}
            >
              <span className={togglePassword2 ? "" : "show"}></span>
            </div>
            </InputGroup>
          </FormGroup>
}
        {step2 &&
        <FormGroup>
          <Label>{t("Password")}</Label>
          <InputGroup>
            <InputGroupText>
              <Lock />
            </InputGroupText>
            <Input
              className="form-control"
              type={togglePassword ? "text" : "password"}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              required=""
              placeholder="********"
            />
            <div
              className="show-hide"
              onClick={() => setTogglePassword(!togglePassword)}
            >
              <span className={togglePassword ? "" : "show"}></span>
            </div>
          </InputGroup>
        </FormGroup>

}
       <FormGroup className="d-flex justify-content-between align-items-center">
  {<Link
    to={`${process.env.PUBLIC_URL}/forgot-password`}
    className="text-decoration-none"
  >
    Forgot Password?
  </Link>}
  <div style={{ width: '40%' }}>
    <Btn
      attrBtn={{
        color: 'primary',
        className: 'w-100',
        disabled: loading,
        onClick: (e) =>
          step2
            ? handleLogin(e)
            : step
            ? handleOtp(e)
            : handleLogin2(e),
      }}
    >
      {loading ? 'LOADING...' : t('Continue')}
    </Btn>
  </div>
</FormGroup>
<SignInWith t={t} />
{step && (
                  <FormGroup>
                      <Label>Your password must have at least:</Label>
                        <LI>8 to 20 characters</LI>
                     <LI>At least 1 uppercase letter and 1 number</LI>
                       <LI>1 special character (e.g. # ? ! $ &amp; @)</LI>
                    </FormGroup>
       )}

        <div style={{ position: 'absolute', top: 1, right: -60, backgroundColor: '#fff', width: 50, height: 40, alignItems: 'center', display: 'flex', justifyContent:'center', borderRadius: '8px' }}>
        <UL attrUL={{ className: `simple-list flex-row nav-menus` }}>
        <LI attrLI={{ className: 'onhover-dropdown' }}><H6 attrH6={{ className: 'txt-dark mb-0 mt-1' }}>{lang === 'es'? 'NP' : 'EN'}</H6>
            <Language />
          </LI>
          </UL>
        </div>
      </Form>
    </Fragment>
  );
};

export default LoginTab;
